// Valores exatamente como o backend devolve (enums em domain/models/enums.py)
export type ProjectStatus = 'OPPORTUNITY' | 'PROPOSAL' | 'ACTIVE' | 'COMPLETED' | 'CANCELLED';
export type PDIStatus = 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED';
export type VacationStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED';
export type ReimbursementStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'PAID';

type ChipColor = 'default' | 'primary' | 'success' | 'error' | 'warning' | 'info';

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
    OPPORTUNITY: 'Oportunidade', PROPOSAL: 'Proposta', ACTIVE: 'Ativo', COMPLETED: 'Concluído', CANCELLED: 'Cancelado',
};
export const PROJECT_STATUS_COLORS: Record<ProjectStatus, ChipColor> = {
    OPPORTUNITY: 'info', PROPOSAL: 'warning', ACTIVE: 'success', COMPLETED: 'primary', CANCELLED: 'error',
};
export const PDI_STATUS_LABELS: Record<PDIStatus, string> = {
    PENDING: 'Pendente', IN_PROGRESS: 'Em andamento', COMPLETED: 'Concluído', CANCELLED: 'Cancelado',
};
export const PDI_STATUS_COLORS: Record<PDIStatus, ChipColor> = {
    PENDING: 'default', IN_PROGRESS: 'primary', COMPLETED: 'success', CANCELLED: 'error',
};
export const VACATION_STATUS_LABELS: Record<VacationStatus, string> = {
    PENDING: 'Pendente', APPROVED: 'Aprovado', REJECTED: 'Rejeitado', CANCELLED: 'Cancelado',
};
export const VACATION_STATUS_COLORS: Record<VacationStatus, ChipColor> = {
    PENDING: 'warning', APPROVED: 'success', REJECTED: 'error', CANCELLED: 'default',
};
export const REIMBURSEMENT_STATUS_LABELS: Record<ReimbursementStatus, string> = {
    PENDING: 'Pendente', APPROVED: 'Aprovado', REJECTED: 'Rejeitado', PAID: 'Pago',
};
export const REIMBURSEMENT_STATUS_COLORS: Record<ReimbursementStatus, ChipColor> = {
    PENDING: 'warning', APPROVED: 'success', REJECTED: 'error', PAID: 'info',
};

export interface Project {
    id: number;
    name: string;
    description: string;
    status: ProjectStatus;
    start_date: string;
    end_date: string | null;
    allocation_percentage: number;
}

export interface TimeEntryRequest {
    date: string;
    hours: number;
    description: string;
    project_id: number;
}

export interface TimeEntry extends Omit<TimeEntryRequest, 'project_id'> {
    id: number;
    project_id: number;
    project_name: string;
    user_id: number;
    created_at: string;
    updated_at: string;
}

export interface PDIGoal {
    id: number;
    title: string;
    description?: string;
    due_date?: string; // enviado na criação
    deadline?: string | null; // devolvido pelo backend
    status?: PDIStatus;
    completed: boolean;
    completed_at?: string;
}

export interface PDI {
    id: number;
    title: string;
    description: string;
    status: PDIStatus;
    created_at: string;
    updated_at: string;
    goals: PDIGoal[];
}

export interface Reimbursement {
    id: number;
    description: string;
    amount: number;
    receipt_url?: string;
    status: ReimbursementStatus;
    date: string; // data da despesa
    created_at: string; // data da solicitação
    updated_at: string;
    review_notes?: string | null; // parecer do RH (ex.: motivo da recusa)
}

export interface VacationRequest {
    id: number;
    start_date: string;
    end_date: string;
    status: VacationStatus;
    notes?: string;
    created_at: string;
    processed_at?: string;
    review_notes?: string | null; // parecer do RH (ex.: motivo da recusa)
}

export interface Task {
    id: number;
    title: string;
    description?: string;
    due_date?: string;
    completed: boolean;
    completed_at?: string;
    created_at: string;
} 